import { AccessoryCategory } from '../Constants';
import { TirePressureDtoResponse } from './tire-pressure.dto-response';

export class Product {
  constructor(product?: Product) {
    Object.assign(this, product);
  }

  id: string;
  quantity: number;
	originalQty?: number;
  type: string;
  warningNotes: string[];
  // djb:refactor to use AccessoryCategory enum
  //category?: number;
  category?: AccessoryCategory;
  tirePressure?: TirePressureDtoResponse[];
  pairNo: string;
  sequence?: number;
  isKit?: boolean;
  isKitComponent?: boolean;
  kitID?: string;
  position?: string;
  brand?: string;
  labours?: string[];
  parentId?: string;
  // WIP - VOLUME DISCOUNT
  volumeDiscount?: string;
  isVolumeDiscountEligible?: boolean = false;
  freeWMB?: boolean = false;
  wmbRequired?: boolean = false;
}
